import { REDUX_LOCAL_HAS_ASSOCIATION_CHANGE_KEY } from 'modules/redux/constants/local-key'

const WORKOUT_CLASS_NAME = 'Workout'

const WORKOUT_KEY = {
  ID: 'id',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CLASS_NAME: 'className',
  DURATION: 'duration',
  NAME: 'name',
  LEVEL: 'level',
  TYPES: 'types',
  EQUIPMENT: 'equipment',
  MUSCLES: 'muscles',
  SECONDARY_MUSCLES: 'secondaryMuscles',
  COMPLETION_TIME: 'completionTime',
  FEATURED_AT: 'featuredAt',
  RECOMMENDED_AT: 'recommendedAt',
  LOGGED_AT: 'loggedAt',
  STARTED_AT: 'startedAt',
  PLANNED_AT: 'plannedAt',
  SUGGESTED_AT: 'suggestedAt',
  DIFFICULTY: 'difficulty',
  NOTES: 'notes',
  INSTRUCTIONS: 'instructions',
  SHARE_KEY: 'shareKey',
  IMAGE: 'image',
  PROFILES_WHO_STARTED: 'profilesWhoStarted',

  // Foreign keys
  PROFILE_ID: 'profileId',
  PLAN_ID: 'planId',
  PARENT_ID: 'parentId',
  ORIGINAL_PARENT_ID: 'originalParentId',
  // Associations
  PARENT: 'parent',
  RECOMMENDED: 'recommended',
  EXERCISE_LOGS: 'exerciseLogs',
  WORKOUT_SECTIONS: 'workoutSections',
  // Local -- not understood by the server
  LOCAL_HAS_ASSOCIATION_CHANGE: REDUX_LOCAL_HAS_ASSOCIATION_CHANGE_KEY,
  LOCAL_IS_DOWNLOADED: 'localIsDownloaded',
  LOCAL_IS_SUGGESTED: 'localIsSuggested',
  LOCAL_IS_REORDERING_WORKOUT_SECTIONS: 'localIsReorderingWorkoutSections',
  LOCAL_IS_REORDERING_WORKOUT_EXERCISES: 'localIsReorderingWorkoutExercises'

}

export {
  WORKOUT_CLASS_NAME,
  WORKOUT_KEY
}
